import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var CloseSmall = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M13.707 12.293a.999.999 0 11-1.414 1.414L8 9.414l-4.293 4.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L6.586 8 2.293 3.707a.999.999 0 111.414-1.414L8 6.586l4.293-4.293a.999.999 0 111.414 1.414L9.414 8z" })), '0 0 16 16', 'CloseSmall');
//# sourceMappingURL=CloseSmall.js.map